var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('p',{staticClass:"content"},[_vm._v("Copyright © 2010-2021 · All Rights Reserved")])])
}]

export { render, staticRenderFns }